import { render } from "./HypertensionDetails.vue?vue&type=template&id=057930f2"
import script from "./HypertensionDetails.vue?vue&type=script&lang=js"
export * from "./HypertensionDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__